import { Injectable, inject } from '@angular/core';
import { ApiService } from '@services/api/api.service';
import { ApiResponse } from '@interfaces/response';
import {Observable} from 'rxjs';
import {Prefix} from '@interfaces/prefix';


@Injectable({
  providedIn: 'root'
})
export class SettingsApiService {

  private api_service = inject(ApiService);

  private prefix_url: string = '/settings/prefix-phone/list';

  constructor() { }

  public get_prefixes(): Observable<ApiResponse<Prefix[]>> {
    return this.api_service.get<ApiResponse<Prefix[]>>(this.prefix_url);
  }
}
